import { render, staticRenderFns } from "./MarketingBanner.vue?vue&type=template&id=4e08170a&scoped=true&"
import script from "./MarketingBanner.vue?vue&type=script&lang=js&"
export * from "./MarketingBanner.vue?vue&type=script&lang=js&"
import style0 from "./MarketingBanner.vue?vue&type=style&index=0&id=4e08170a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e08170a",
  null
  
)

export default component.exports